export default class IndexedDBUtil
{
	static DB = {name:"formRes",name2:"pivotTmp",name3:"logTmp",name4:"clientopr",name5:"performanceTiming",name6:"requestHttp",name7:"performanceMemory"};

	static openDB(name,callBack,version)
	{
		var _name = name || IndexedDBUtil.DB.name;
        var _version=version || 4;
        var _indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.msIndexedDB;
        var request=_indexedDB.open(_name,_version);

        request.onerror=IndexedDBUtil.dbOnError;
        request.onsuccess=function(e){IndexedDBUtil.dbOnSuccess(e,callBack);};
        request.onupgradeneeded=IndexedDBUtil.dbOnupgradeneeded;
    }

    static dbOnError(e)
    {
    	alert(e.currentTarget.error.message);
    }

    static dbOnSuccess(e,callBack)
    {
        IndexedDBUtil.DB.db=e.target.result;
        if(callBack)
        {
            callBack();
        }
    }

    static dbOnupgradeneeded(e)
    {
    	var db=e.target.result;
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name))
        {
            db.createObjectStore(IndexedDBUtil.DB.name,{keyPath:"id"});
        }
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name2))
        {
            db.createObjectStore(IndexedDBUtil.DB.name2,{keyPath:"id"});   
            //alert("dbOnupgradeneeded      " + IndexedDBUtil.DB.name2);
        }
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name3))
        {
            db.createObjectStore(IndexedDBUtil.DB.name3,{keyPath:"id"});   
            //alert("dbOnupgradeneeded      " + IndexedDBUtil.DB.name2);
        }
        
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name4))
        {
            db.createObjectStore(IndexedDBUtil.DB.name4,{keyPath:"id"});   
        }
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name5))
        {
            db.createObjectStore(IndexedDBUtil.DB.name5,{keyPath:"id"});   
        }
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name6))
        {
            db.createObjectStore(IndexedDBUtil.DB.name6,{keyPath:"id"});   
        }
        if(!db.objectStoreNames.contains(IndexedDBUtil.DB.name7))
        {
            db.createObjectStore(IndexedDBUtil.DB.name7,{keyPath:"id"});   
        }
    }

    static addData(db,storeName,data)
    {
        if(db){
            var transaction=db.transaction(storeName,'readwrite'); 
            var store=transaction.objectStore(storeName);
            var request=store.get(data.id); 
            request.onsuccess=function(e){ 
                store.put(data); 
            };
        }
        //store.add(data);
    }

    static getDataById(id,storeName,callBack)
    {
        if(IndexedDBUtil.DB.db){
            var transaction  = IndexedDBUtil.DB.db.transaction(storeName);
            var store = transaction.objectStore(storeName);
            
            if(!id)
            {
                alert("在访问数据库时未指定id");
                return;
            }
            var request=store.get(id);
            request.onsuccess=callBack;
            request.onerror=function(e){
                   alert(e.target.error);
            }
        }
    }
    
    static getAllDataAndDelete(storeName,callback)
    {
        var transaction  = IndexedDBUtil.DB.db.transaction(storeName,'readwrite');
        var store = transaction.objectStore(storeName);
        
        let request = store.openCursor();
        let data = [];
        request.onerror = function () 
        {
            alert("上传网络错误日志时在获取浏览器数据库数据错误");
        };
        request.onsuccess = function (e) 
        {
            let result = e.target.result;
            if (result && result !== null) 
            {
                if(result.value && result.value.id && result.value.data)
                    data.push(result.value.data);
                result.delete();
                result.continue();
            } 
            else 
            {
                if (callback) 
                {
                    //console.log('全部查找数据成功')
                    callback(data);
                }
            }
        };
    }

    static getAllData(storeName,callback)
    {
        var transaction  = IndexedDBUtil.DB.db.transaction(storeName,'readwrite');
        var store = transaction.objectStore(storeName);
        
        let request = store.openCursor();
        let data = [];
        request.onerror = function () 
        {
            alert("查看网络错误日志时在获取浏览器数据库数据错误");
        };
        request.onsuccess = function (e) 
        {
            let result = e.target.result;
            if (result && result !== null) 
            {
                if(result.value && result.value.id && result.value.data)
                    data.push(result.value.data);
                //result.delete();
                result.continue();
            } 
            else 
            {
                if (callback) 
                {
                    //console.log('全部查找数据成功')
                    callback(data);
                }
            }
        };
    }


}


// WEBPACK FOOTER //
// ./src/utils/IndexedDBUtil.js